import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

// element ui
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import Vant from 'vant';
import 'vant/lib/index.css';
import 'lib-flexible'
import VueClipboard from 'vue-clipboard2'
Vue.use(ElementUI);
Vue.use(Vant);
Vue.use(Axios)
Vue.use(VueClipboard)
import { Swipe, SwipeItem } from 'vant';
Vue.use(Swipe);
Vue.use(SwipeItem);
// 初始化样式
import "./assets/css/base.css"
import Axios from 'axios';
// 设置当前组件网页标题
router.beforeEach((to, from, next) => {
  /* 路由发生变化修改页面title */
  if (to.meta.title) {
    document.title = to.meta.title
  }
  next()
})
Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
